export const DEPOSIT = 'DEPOSIT';
export const PERSONAL_LOAN = 'PERSONAL_LOAN';
export const PERSONAL_CREDIT_LINE = 'PERSONAL_CREDIT_LINE';
export const HOME_IMPROVEMENT_CREDIT_LINE = 'HOME_IMPROVEMENT_CREDIT_LINE';
export const BUY_NOW_PAY_LATER = 'BUY_NOW_PAY_LATER';
export const AUTO_PRE_QUALIFICATION = 'AUTO_PRE_QUALIFICATION';
export const CASH_ADVANCE = 'CASH_ADVANCE';